module.exports = __webpack_public_path__ + "static/media/praiseDark.e0b7c4c4.svg";